export default {
  title: "Centropa",
  subtitle: "Projekt",
  paragraph: "Bald verfügbar ...",

  custom404Title: "Diese Seite konnte leider nicht gefunden werden!",
  custom404Button: "Zurück",
};
